var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByTheNumbersCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 66,
    viewBox: "0 0 59 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2094 3.16717L34.2162 3.17528L34.2232 3.18325L40.7467 10.5882L40.7469 10.5884L56.1936 28.1141L56.1936 28.1141C58.6021 30.8467 58.6021 35.1556 56.1936 37.8881L56.1936 37.8881L36.1975 60.5767L36.1974 60.5768L34.2235 62.8155L34.2163 62.8237L34.2093 62.832C33.6388 63.5082 32.9215 64.0542 32.1075 64.4296C31.2936 64.805 30.4039 65 29.5024 65C28.6009 65 27.7113 64.805 26.8973 64.4296C26.0834 64.0542 25.366 63.5082 24.7956 62.832L24.7887 62.8239L24.7817 62.816L22.8755 60.6513L22.8751 60.6509L2.80641 37.8865C0.397875 35.154 0.397865 30.8451 2.80637 28.1126C2.80638 28.1125 2.8064 28.1125 2.80641 28.1125L22.875 5.34674L22.8751 5.34653L24.7828 3.1837L24.79 3.17551L24.7971 3.16717C25.3675 2.49123 26.0848 1.94542 26.8986 1.57021C27.7125 1.19497 28.6019 1 29.5032 1C30.4045 1 31.294 1.19497 32.1078 1.57021L32.5266 0.662086L32.1078 1.57021C32.9216 1.94542 33.6389 2.49123 34.2094 3.16717Z",
    fill: "#FFEFBE",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 37.7792L23.6523 29.1373C24.0292 28.7609 24.635 28.746 25.03 29.1034L30.795 34.3198C31.19 34.6771 31.7958 34.6622 32.1727 34.2858L41.5 24.9697M41.5 24.9697H32.5M41.5 24.9697V32.96",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByTheNumbersCheck);
export default __webpack_public_path__ + "static/media/by-the-numbers-check.ab1d2df85209280bb35b8424144a204c.svg";
export { ForwardRef as ReactComponent };